var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252 252",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.2,25.2) scale(0.8,0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "none",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,252v-252h252v252z",
    fill: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#f7f7fb",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.34375,17.71875h-118.71562c-4.92187,0 -9.05625,4.13437 -9.05625,9.05625v198.45c0,4.92188 4.13437,9.05625 9.05625,9.05625h154.54688c4.92188,0 9.05625,-4.13437 9.05625,-9.05625v-162.42187l-44.8875,-45.08437v36.02813c0,4.92188 4.13437,9.05625 9.05625,9.05625h36.02813"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#dedfe6",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.54062,186.04688h-86.82187c-3.34688,0 -5.90625,-2.55937 -5.90625,-5.90625c0,-3.34688 2.55937,-5.90625 5.90625,-5.90625h86.82187c3.34688,0 5.90625,2.55937 5.90625,5.90625c0,3.34688 -2.55937,5.90625 -5.90625,5.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dedfe6",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.54062,150.01875h-86.82187c-3.34688,0 -5.90625,-2.55937 -5.90625,-5.90625c0,-3.34688 2.55937,-5.90625 5.90625,-5.90625h86.82187c3.34688,0 5.90625,2.55937 5.90625,5.90625c0,3.34688 -2.55937,5.90625 -5.90625,5.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dedfe6",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.54062,113.79375h-86.82187c-3.34688,0 -5.90625,-2.55937 -5.90625,-5.90625c0,-3.34687 2.55937,-5.90625 5.90625,-5.90625h86.82187c3.34688,0 5.90625,2.55938 5.90625,5.90625c0,3.34688 -2.55937,5.90625 -5.90625,5.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#464c55",
    strokeWidth: 11.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.42813,62.80312"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#464c55",
    strokeWidth: 11.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.42813,62.80312"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#464c55",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.5625,58.66875l-45.08438,-45.08437c-1.18125,-0.98437 -2.95312,-1.77188 -4.725,-1.77188v0h-118.125c-8.26875,0 -14.9625,6.69375 -14.9625,14.9625v198.45c0,8.26875 6.69375,14.9625 14.9625,14.9625h154.74375c8.26875,0 14.9625,-6.69375 14.9625,-14.9625v-162.42187c0,-1.575 -0.7875,-3.15 -1.77187,-4.13437zM173.25,31.89375l25.00313,25.00312h-21.85313c-1.77187,0 -3.15,-1.37812 -3.15,-3.15zM206.325,225.225c0,1.77187 -1.37813,3.15 -3.15,3.15h-154.54687c-1.77187,0 -3.15,-1.37813 -3.15,-3.15v-198.45c0,-1.77188 1.37812,-3.15 3.15,-3.15h112.6125v30.12188c0,8.26875 6.69375,14.9625 14.9625,14.9625h30.12187z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b232718c59d91db7857a48fdcc861bf8.svg";
export { ForwardRef as ReactComponent };